import en from "./en.json";
import es from "./es.json";
import it from "./it.json";
import pt from "./pt.json";

export default {en, es, it, pt};